import { useEffect, useState } from "react";

export default function LoadingScreen() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 99) {
          clearInterval(interval);
          return 99;
        }
        // Randomize increment for realistic "loading" feel
        return prev + Math.floor(Math.random() * 15) + 1;
      });
    }, 150);
    return () => clearInterval(interval);
  }, []);

  const displayProgress = Math.min(progress, 99);

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-oditi-bg cursor-wait">
      <div className="relative">
        <h1 className="font-display text-[15vw] md:text-[12vw] leading-none font-bold tracking-tighter text-oditi-black mix-blend-difference">
          {displayProgress}%
        </h1>
      </div>
      <div className="absolute bottom-12 left-0 w-full px-8 flex justify-between font-mono text-xs uppercase text-oditi-black">
        <span>Decrypting Assets</span>
        <span>Secure Connection</span>
        <span>Oditi Protocol v1.0</span>
      </div>
    </div>
  );
}
